import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  :root {
    --Neutral-White: #fff;
    --Neutral-Gray50: #fcfcfc;
    --Neutral-Gray100: #F9F9FA;
    --Neutral-Gray300: #e6e8eb;
    --Neutral-Gray400: #a1a5b0;
    --Neutral-Gray500: #838792;
    --Neutral-Gray600: #525b75;
    --Neutral-Gray800: #212C4E;
    --Danger-red: #ff6f61;
    --Success-500: #22c55e;
  }

  body {
    overflow-y: scroll;
    height: auto;
  }

  *:not(.icon),
  input::placeholder {
    font-family: 'Roboto';
  }

  .fr-view *:not(.icon) {
    font-family: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  .modal .header {
    .icon {
      top: 3px;
    }
  }

  h2 {
    font-size: 25px;
  }

  h2,
  h3,
  h4 {
    color: #012d3e;
  }

  h4 {
    font-weight: 300 !important;
  }

  img {
    width: 100%;
    height: auto;
  }

  strong {
    font-weight: 500;
  }

  a {
    cursor: pointer;
  }

  ul {
    margin: 0rem;
    padding: 0 2rem;
    text-align:left;

    li {
      margin-bottom: 1rem;
    }
  }

  input[type="color"] {
    background: #fff !important;
    height: 35px !important;
    border-radius: 4px !important;
    border: 1px solid #bdcbd0 !important;
    box-shadow: 0px 2px 12px -5px rgb(0 46 62 / 5%) !important;
  }

  .gantt {
    svg {
      z-index: 5;
      pointer-events: none;
      margin-top: 0.5em;

      foreignObject > div {
        min-width: 25px;
      }
    }
  }

  label .icon {
    position: relative;
    top: -1px !important;
    left: 5px;
    margin: 0;
  }

  i.icon {
    font-family: 'hrskyen-icons' !important;

    /* map to icon-close-x */
    &.remove:before,
    &.delete:before,
    &.close:before {
      content: '\\6e' !important;
    }
  }
  .ui.dimmer:not(.inverted):not(.dark) {
    background-color: #012d3e20 !important;
    backdrop-filter: blur(2px) !important;
    ${({ theme }) => theme.mediaQueries.mobile} {
      padding: 0;
    }
  }

  .ui.fluid.container {
    max-width: 93% !important;
    margin-bottom: 1rem;

    ${({ theme }) => theme.mediaQueries.mobile} {
      flex-direction: column;
      max-width: 100% !important;
      margin: 0 !important;
    }

    .switch-wrapper {
      position: relative;
    }

    .switch-wrapper > div {
      position: absolute;
      width: 100%;
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    .ui.dimmer::-webkit-scrollbar-track {
      background: rgba(230, 230, 230, 1) !important;
    }
    .ui.dimmer::-webkit-scrollbar-thumb {
      background: rgba(190, 190, 190, 1) !important;
    }
  }

  .ui.label {
    background: ${({ theme }) => theme.colors.lightGrey} !important;
    color: ${({ theme }) => theme.colors.abyss} !important;
    white-space: nowrap !important;
    border-radius: 3px !important;
    font-size: 14px !important;
    font-weight: 300 !important;
    padding: 5px 10px !important;
    box-shadow: none !important;
    cursor: default;

    .delete.icon {
      font-size: 10px !important;
      top: 1px;
    }

    img {
      margin: -5px 10px -5px -10px !important;
      height: 24px !important;
    }
  }

  .ui.popup {
    border: 1px solid #dbe2e4;
    box-shadow:  0px 2px 12px -5px rgba(0, 46, 62, 0.1);;

    &&&.right:before {
      box-shadow: -1px 1px 0 0 #c9ced7;
    }

    &&&.left:before {
      box-shadow: 1px -1px 0 0 #c9ced7;
    }

    &&&.top:before {
      box-shadow: 1px 1px 0 0 #c9ced7;
    }

    &&&.bottom:before {
      box-shadow: -1px -1px 0 0 #c9ced7;
    }
  }

  .ui.divider:not(.hidden):not(.horizontal) {
    border-top: 1px solid #E5EAEB !important;
    border-bottom: 0 !important;
  }

  /**
  * Froala Wysiwyg
  */
  .fr-box {
    button[id*='imageManager'] {
      display: none !important;
    }

    .fr-toolbar,
    .fr-wrapper,
    .second-toolbar {
      border-color: rgba(34, 36, 38, 0.15) !important;
    }

    .fr-toolbar {
      border-top-left-radius: 4px !important;
      border-top-right-radius: 4px !important;
    }

    .second-toolbar {
      border-bottom-left-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    }
  }
  .fr-buttons {
    #videoEmbed-1,
    #videoByURL-1,
    #videoUpload-1 {
      display: none;
    }
  }
  .tribute-container {
    box-shadow: 0 2px 4px 0 rgba(34, 36, 38, 0.12),
      0 2px 10px 0 rgba(34, 36, 38, 0.15);
    border-radius: 4px;

    ul {
      background: #fff !important;

      li {
        padding: 0.5em !important;
        margin: 0 !important;

        &.highlight,
        &:hover {
          background: #efefef !important;
        }
      }
    }
  }
  .LinesEllipsis-canvas {
    visibility: hidden;
  }
  .helpkit-launcherButton {
    display: none !important;
  }
  @media only screen and (max-width: 1319px) {
    .ui.fluid.container {
      max-width: calc(100% - 1em) !important;
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    .ui.fluid.container {
      max-width: 100% !important;
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    body > .modals {
      bottom: 75px;
      padding-top: 15px !important;
      padding-bottom: 90px !important;
    }
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    body > .modals {
      .modal.scrolling {
        width: calc(100% - 30px) !important;
      }
    }
  }
  .rdw-image-modal-size {
    display: none !important;
  }
`
export default GlobalStyles
